import { createIcon } from '@consta/icons/Icon'
import type { FC, SVGProps } from 'react'

const IconStratigraphyM: FC<SVGProps<SVGSVGElement>> = props => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 10" {...props}>
      <path d="M 14 2.5 C 14 3.8807 12.8807 5 11.5 5 C 10.2905 5 9.2816 4.1411 9.05 3 H 8.7297 C 8.253 3 7.8426 3.3365 7.7491 3.8039 L 7.2315 6.3922 C 7.0445 7.3271 6.2237 8 5.2703 8 H 4.95 C 4.7184 9.1411 3.7095 10 2.5 10 C 1.1193 10 0 8.8807 0 7.5 C 0 6.1193 1.1193 5 2.5 5 C 3.7095 5 4.7184 5.8589 4.95 7 H 5.2703 C 5.747 7 6.1574 6.6635 6.2509 6.1961 L 6.7685 3.6078 C 6.9555 2.6729 7.7763 2 8.7297 2 H 9.05 C 9.2816 0.8589 10.2905 0 11.5 0 C 12.8807 0 14 1.1193 14 2.5 Z M 13 2.5 C 13 1.6716 12.3284 1 11.5 1 C 10.6716 1 10 1.6716 10 2.5 C 10 3.3284 10.6716 4 11.5 4 C 12.3284 4 13 3.3284 13 2.5 Z M 2.5 9 C 3.3284 9 4 8.3284 4 7.5 C 4 6.6716 3.3284 6 2.5 6 C 1.6716 6 1 6.6716 1 7.5 C 1 8.3284 1.6716 9 2.5 9 Z" />
    </svg>
  )
}

export const IconStratigraphy = createIcon({
  l: IconStratigraphyM,
  m: IconStratigraphyM,
  s: IconStratigraphyM,
  xs: IconStratigraphyM,
  name: 'IconStratigraphy',
})
